import { topics } from '@/mocks/home-data';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer no-underline border ${
                topic.hot
                  ? 'bg-primary-100/80 text-primary-700 border-primary-200 hover:bg-primary-200/80'
                  : 'bg-background-100 text-foreground-600 border-background-200 hover:bg-background-200/70 hover:text-foreground-800'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              <span>{topic.name}</span>
              <span className="text-xs opacity-60">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}